import {
  ErrorMsgServiceClient,
  SendErrorMsgRequest,
} from '../proto/admpb/errormsg_grpc_web_pb';
import { auth } from '../lib/auth/Auth';

const service = new ErrorMsgServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function sendErrorMsg(param) {
  return new Promise((resolve, reject) => {
    let req = new SendErrorMsgRequest();
    req.setErrorMsg(param.errorMsg);
    req.setType(param.setType);
    req.setCriticalLevel(param.criticalLevel);

    service.sendErrorMsg(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
